import React from 'react';
import pdfFile from '../assets/files/2025.pdf';

const NIRF2025 = () => {
  const handleOpenPDF = () => {
    window.open(pdfFile, '_blank');
  };

  return (
    <div className="container py-5">
      <div className="card shadow p-4 border-0">
        <div className="text-center mb-4">
          <h1 className="text-primary fw-bold">National Institutional Ranking Framework</h1>
          <h5 className="text-secondary">Ministry of Education, Government of India</h5>
        </div>

        <div className="nirf-content text-center">
          <p className="fw-semibold fs-5 text-dark">
            Submitted Institute Data for NIRF'2025
          </p>
          <p className="fs-6 text-muted">[IR-O-C-52006]</p>

          <div className="mt-4">
            <button className="btn btn-primary" onClick={handleOpenPDF}>
              View Submitted Data (PDF)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NIRF2025;
